document.addEventListener('alpine:init', () => {
  Alpine.data('ProductFormQuantity', () => ({
    qty: 1,
    $qtyWrap: null,
    $qty: null,
    $section: null,
    init() {
      let am = this;

      document.addEventListener('init-ProductFormQuantity', (e) => {
        if (am.$qtyWrap) return;

        am.$qtyWrap = e.target;
        let $qty = am.$qtyWrap.querySelector('[name=quantity]');
        am.$qty = $qty;
        am.InitVariantPriceUpdate();
      });
    },

    FormQtyChange(e) {
      let am = this;
      if (e.target.classList.contains('js-qty-down')) {
        let newQty = am.qty - 1;
        am.qty -= (newQty > 1) ? 1 : 0;
      }
      else if (e.target.classList.contains('js-qty-up')) {
        am.qty += 1;
      }
      else {
        let $qty = am.$qtyWrap.querySelector('[name="quantity"]');
        let qty = parseInt($qty.value);
        am.qty = qty;  
      }

      setTimeout(() => {
        am.$qtyWrap.dispatchEvent(new CustomEvent('update-variant-price'));
      }, 0);
  },

    InitVariantPriceUpdate() {
      let am = this;

      am.$qtyWrap.addEventListener('update-variant-price', (e) => {
        // console.log(e);
        let qty = parseInt(am.$qtyWrap.querySelector('[name=quantity]').value);

        let variant_price = parseFloat(am.$qtyWrap.dataset.variantPrice);
        let product_id = am.$qtyWrap.dataset.productId;
        let total_price = qty * variant_price;
        let $form = document.querySelector(`.product_form[data-product-id="${ product_id }"]`);

        // update main form qty
        $form.querySelectorAll('[name="quantity"]').forEach(($qty) => {
          $qty.value = qty;
          $qty.dispatchEvent(new Event('change'));
        });

        // update prices
        $form.querySelectorAll('[data-regular-price]').forEach(($price) => {
          $price.textContent = WAU.Helpers.formatMoney(total_price, '${{amount}}');
        });
      });
    }
  }));
});
